import { formatUnits } from 'viem';
import { TOKEN_DECIMALS } from '../config';
import { TokenAddress } from '../config';

export const formatTokenAmount = (amount: bigint, tokenAddress?: TokenAddress): string => {
  const decimals = tokenAddress ? TOKEN_DECIMALS[tokenAddress] || 18 : 18;
  const formatted = formatUnits(amount, decimals);
  const [whole, decimal] = formatted.split('.');
  const formattedWhole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  if (decimal) {
    const significantDecimals = decimal.slice(0, 4).replace(/0+$/, '');
    return significantDecimals ? `${formattedWhole}.${significantDecimals}` : formattedWhole;
  }
  return formattedWhole;
};

// Serialize data with BigInt support
export function serializeWithBigIntSupport(data: any): string {
  return JSON.stringify(data, (key, value) => {
    if (typeof value === 'bigint') {
      return value.toString();
    }
    return value;
  }, 2);
} 